import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import useGoogle from 'react-google-autocomplete/lib/usePlacesAutocompleteService';
import Loader from '../../Components/Loader/Loader';
import { serviceConsumer } from '../../network/ServiceConsumer';
import { getAddressObject } from '../../helper/getAddressObject';

// Oireachtas Venue tab (functional). Updates the event created on the previous
// step (PUT /oireachtas/:id), with Google Places address autocomplete (reused
// from the feis venue: usePlacesAutocompleteService + getAddressObject).
const VenueFies = (props) => {
  const [loading, setLoading] = useState(false);
  const EventID = localStorage.getItem('ID');
  const [form, setForm] = useState({
    venue_name: '', venue_address: '', venue_city: '', state: '', postal_code: '',
    latitude: '', longitude: '',
  });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const { placesService, placePredictions, getPlacePredictions } = useGoogle({
    apiKey: process.env.REACT_APP_GOOGLE_API,
    options: { componentRestrictions: { country: ['ca', 'USA'] } },
  });

  useEffect(() => {
    (async () => {
      if (!EventID) return;
      try {
        setLoading(true);
        const res = await serviceConsumer('GET', `${process.env.REACT_APP_BASE_URL}/oireachtas/${EventID}`);
        const ev = res.event;
        if (ev) setForm((f) => ({
          ...f,
          venue_name: ev.venue_name || '', venue_address: ev.venue_address || '',
          venue_city: ev.venue_city || '', state: ev.state || '', postal_code: ev.postal_code || '',
          latitude: ev.latitude || '', longitude: ev.longitude || '',
        }));
      } catch (e) { /* ignore */ } finally { setLoading(false); }
    })();
  }, [EventID]);

  // On selecting a prediction: pull details, fill address/city/state/zip + lat/long.
  const pickPlace = (placeId) => {
    placesService?.getDetails({ placeId }, (place) => {
      if (!place) return;
      const a = getAddressObject(place.address_components || []);
      setForm((f) => ({
        ...f,
        venue_address: place.formatted_address || f.venue_address,
        venue_city: a.city || f.venue_city,
        state: a.region || f.state,
        postal_code: a.postal_code || f.postal_code,
        latitude: place.geometry?.location?.lat()?.toString() || f.latitude,
        longitude: place.geometry?.location?.lng()?.toString() || f.longitude,
      }));
    });
    getPlacePredictions({ input: '' }); // clear the dropdown
  };

  const isValid = form.venue_name && form.venue_city;

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await serviceConsumer('PUT', `${process.env.REACT_APP_BASE_URL}/oireachtas/${EventID}`, { ...form, page: 2 });
      if (res.success) {
        localStorage.setItem('TAB', 3);
        if (Number(localStorage.getItem('page')) < 2) localStorage.setItem('page', 2);
        setTimeout(() => props.setValue('3'), 200);
      }
    } catch (err) {
      toast.error(err?.messages || err?.message || 'Failed to save venue. Please try again.');
    } finally { setLoading(false); }
  };

  const grid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', maxWidth: 900 };
  const lbl = { fontSize: 14, fontWeight: 600, display: 'block', marginBottom: 6 };
  const inp = { width: '100%', padding: '9px 12px' };
  const field = (label, k) => (
    <div className="mb-3" key={k}>
      <label style={lbl}>{label}</label>
      <input className="dashboard-input" value={form[k]} onChange={set(k)} style={inp} />
    </div>
  );

  return (
    <div>
      {loading && <Loader />}
      {!loading && (
        <form className="form form-label-right" autoComplete="off" onSubmit={submit}>
          <div className="detailsHeaders">
            <h4 className="eventPage">Venue</h4>
            <p className="eventDescription">Where is the Oireachtas held?</p>
          </div>

          <div style={{ maxWidth: 900 }}>
            <div style={grid}>{field('Venue Name', 'venue_name')}<div /></div>

            {/* Address with Google Places autocomplete */}
            <div className="mb-3" style={{ position: 'relative' }}>
              <label style={lbl}>Address <span style={{ fontWeight: 400, color: '#797979' }}>(start typing to autofill)</span></label>
              <input
                className="dashboard-input"
                value={form.venue_address}
                onChange={(e) => { set('venue_address')(e); getPlacePredictions({ input: e.target.value }); }}
                style={inp}
                autoComplete="off"
              />
              {placePredictions?.length > 0 && (
                <ul style={{ listStyle: 'none', margin: '2px 0 0', padding: 0, position: 'absolute', zIndex: 20, background: '#fff', width: '100%', border: '1px solid #dcdcdc', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', maxHeight: 220, overflowY: 'auto' }}>
                  {placePredictions.map((p) => (
                    <li key={p.place_id} onClick={() => pickPlace(p.place_id)}
                      style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 14 }}
                      onMouseDown={(e) => e.preventDefault()}>
                      {p.description}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div style={grid}>
              {field('City', 'venue_city')}
              {field('State / Province', 'state')}
              {field('Postal Code', 'postal_code')}
              <div />
            </div>
          </div>

          <div className="mt-4 mb-5" style={{ maxWidth: 900, textAlign: 'right' }}>
            <button className={isValid ? 'filled' : 'disabled'} type="submit" disabled={!isValid}>Next</button>
          </div>
        </form>
      )}
      <ToastContainer />
    </div>
  );
};

export default VenueFies;
